export default __webpack_public_path__ + "static/media/icon-close.ecd47fa0.svg";